import React from 'react';

interface InlineDropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  value: string;
  minWidth?: number; // in ch units
  className?: string;
  options: { value: string; label: string }[];
}

const InlineDropdown = ({ 
  value, 
  minWidth = 1, 
  className,
  style,
  options,
  ...props 
}: InlineDropdownProps) => {
  // Find the selected option to determine width
  const selectedOption = options.find(opt => opt.value === value);
  const textToMeasure = selectedOption ? selectedOption.label : '';
  const length = textToMeasure.length;
  const effectiveWidth = Math.max(length, minWidth);

  return (
    <select
      value={value}
      style={{
        background: 'transparent',
        border: '1px dashed var(--bs-border-color, #666)',
        color: 'var(--bs-body-color, inherit)',
        fontFamily: 'inherit',
        padding: '0 0.2em',
        display: 'inline-block',
        width: `calc(${effectiveWidth}ch + 1.5em)`, // Add extra padding for the arrow
        transition: 'width 0.3s ease-out',
        cursor: 'pointer',
        ...style,
      }}
      className={['of-themed-dropdown', className].filter(Boolean).join(' ')}
      {...props}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default InlineDropdown;
